const emptyData = {
  '@context': {
    '@vocab': 'https://www.w3.org/ns/activitystreams#',
    atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
    schema: 'http://schema.org/'
  },
  '@type': 'Object'
};
export const getEmptyJsonLd = () => emptyData;
export const getUnauthorizedJsonLd = () => ({
  meta: {
    visibility: 'restricted',
    access: 'unauthorized',
    auth: [],
    definitionId: 'provider-not-found'
  },
  data: {
    ...emptyData
  }
});
export const getForbiddenJsonLd = () => ({
  meta: {
    visibility: 'restricted',
    access: 'forbidden',
    auth: [],
    definitionId: 'provider-not-found'
  },
  data: {
    ...emptyData
  }
});